import React from "react";
import {AvatarStyleIndexOptions} from "../../../../../../../../../../constant";

const AvatarStyleSelector = ({selectedAvatarIndex, setSelectedAvatarIndex}) => {
  return (
    <div className="styles-wrapper">
      {AvatarStyleIndexOptions.map((item) => (
        <div className="circle" key={item.type}>
          <div className="tooltip-container">
            <div className="tooltip-box">{item.name}</div>
          </div>
          <img
            className={selectedAvatarIndex === item.type ? "option-item active" : "option-item"}
            alt="icon"
            src={item.icon}
            onClick={() => setSelectedAvatarIndex(item.type)}
          />
        </div>
      ))}
    </div>
  );
};

export default AvatarStyleSelector;
